// extracted by mini-css-extract-plugin
export default {"marginTop":"marginTop---SPDK2"};